import { Icon, List } from '@atom/mui';
import {
  DescriptionIcon,
  type IconComponent,
  InsertDriveFileIcon,
  InsertPhotoIcon,
  MovieIcon,
} from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import { MediaType } from '@atom/types/media';

import { MEDIA_TYPE_LABELS } from './constants';

import classes from './filesTab.module.css';

const { ListItemButton, ListItemText } = List;

const MEDIA_TYPES: MediaType[] = [
  MediaType.DOCUMENT,
  MediaType.IMAGE,
  MediaType.VIDEO,
];

const MEDIA_TYPE_ICONS: Record<MediaType, IconComponent> = {
  [MediaType.DOCUMENT]: InsertDriveFileIcon,
  [MediaType.IMAGE]: InsertPhotoIcon,
  [MediaType.VIDEO]: MovieIcon,
  [MediaType.REPORT]: DescriptionIcon,
};

const styles = {
  selectedNode: {
    boxSizing: 'border-box',
    backgroundColor: colors.utility.highlight,
    borderLeft: `3px solid ${colors.brand.blue}`,
    height: '3.125rem',
  },
  listNode: {
    boxSizing: 'border-box',
    borderLeft: '3px solid transparent',
    height: '3.125rem',
  },
};

type MediaTotalListProps = {
  selectedType: MediaType | null;
  totals: Partial<Record<MediaType, number>>;
  selectMediaType: (mediaType: MediaType) => void;
};

const MediaTotalList = ({
  selectedType,
  totals,
  selectMediaType,
}: MediaTotalListProps) => {
  return (
    <List disablePadding>
      {MEDIA_TYPES.map(type => {
        const rootStyles =
          selectedType === type ? styles.selectedNode : styles.listNode;

        const iconContent = (
          <div className={classes.mediaTotalsIcon}>
            <Icon color={colors.neutral.gray} icon={MEDIA_TYPE_ICONS[type]} />
          </div>
        );

        const content = (
          <div className={classes.mediaTotalsTextContainer}>
            <div className={classes.mediaTotalsType}>
              {MEDIA_TYPE_LABELS[type]}
            </div>
            <div className={classes.mediaTotalsCount}>{totals[type] ?? 0}</div>
          </div>
        );

        return (
          <ListItemButton
            key={type}
            style={rootStyles}
            onClick={() => selectMediaType(type)}
            data-cy={`filesTabCategory-${type}`}
          >
            {iconContent}
            <ListItemText
              primaryTextStyle={{ fontWeight: 'normal' }}
              primary={content}
            />
          </ListItemButton>
        );
      })}
    </List>
  );
};

export default MediaTotalList;
